const RenderIfEnabled = ({ agency, flag, children }) => {
  if (!agency[flag]) {
    return null;
  }
  return children;
};

export default RenderIfEnabled;
